import {CommonService} from "./common/commonService";
import { ServicesConfig } from "./servicesConfig";



export class EdrService {

  
    static listEdarEntidades = (codEdar) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/carto/list/edarEntidades/" + codEdar)
    )
    static findEdarEntidades = (codEdar) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/edr/info/edar/" + codEdar)
    )
    static listEdarFotos = (codEdar) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/edr/fotos/" + codEdar)
    )
    static findEdarFoto = (foto) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/edr/foto/" + foto)
    )
    static listEdarAutocontroles = (codEdar, year, month) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/edr/autocontroles/" + codEdar + "/" + year + "/" + month)
    )
    static getFichasAnualesAnos = (codEdar) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/edr/fichas_anuales/" + codEdar)
    )
    static uploadEdarFoto = (codEdar, body) => (
        CommonService.postPhoto(ServicesConfig.getAbsoluteUrl() + "/edr/foto/" + codEdar, body)
    )
    static removeEdarFoto = (foto) => (
        CommonService.delete(ServicesConfig.getBaseUrl() + "/edr/foto/" + foto)
    )
}